import { QuotaState } from "store/types";

type ProUpgradeCallback = (appID: string) => void;

const pendingProUpgrades: Record<string, QuotaState> = {};
const pendingProCallbacks: Record<string, readonly ProUpgradeCallback[]> = {};

export function registerPendingProUpgradeForBuilderPurchase(
    appID: string,
    quotaInfo: QuotaState,
    onUpgrade?: ProUpgradeCallback
) {
    pendingProUpgrades[appID] = quotaInfo;
    if (onUpgrade !== undefined) {
        const priorCallbacks = pendingProCallbacks[appID] ?? [];
        pendingProCallbacks[appID] = [...priorCallbacks, onUpgrade];
    }
}

export function confirmProUpgrade(appID: string) {
    const quotaInfo = pendingProUpgrades[appID];
    if (quotaInfo === undefined) return;

    const pendingCallbacks = pendingProCallbacks[appID] ?? [];
    for (const pendingCallback of pendingCallbacks) {
        pendingCallback(appID);
    }

    // DELETE
    // This appears unused

    delete pendingProUpgrades[appID];
    delete pendingProCallbacks[appID];
}
